import React from 'react';

const IndexTableContext = React.createContext();
export default IndexTableContext;
